// Shared Dolomite subgraph endpoints — single source of truth for both the
// user-data sub-account enumeration and the public-data market-data route.
//
// Public gateway: the project key is embedded in the URL, so NO API key is
// needed. Source: github.com/dolomite-exchange/dolomite-subgraph
// (`config/subgraph-endpoints.json`) — but several slugs (ethereum, botanix,
// bsc) are live without being listed there; verified June 2026.

const DOLO_KEY = '1301d2d1-7a9d-4be4-9e9a-061cb8611549'
// `latest` tracks the published deployment (pinned versions like v0.1.7 drift;
// the older v0.1.4 path returns a name/version error).
const DOLO_VER = 'latest'

const doloUrl = (slug: string) =>
  `https://subgraph.api.dolomite.io/api/public/${DOLO_KEY}/subgraphs/dolomite-${slug}/${DOLO_VER}/gn`

/**
 * chainId → subgraph URL. Covers every chain that has markets today. Keep in
 * sync as new chains gain markets — a missing entry silently degrades user-data
 * to the default account only (isolated positions use unguessable derived
 * accountNumbers) and disables the public-data subgraph route (on-chain
 * fallback still works).
 */
export const DOLOMITE_SUBGRAPH_URLS: Record<string, string> = {
  '1': doloUrl('ethereum'), // unlisted but live
  '56': doloUrl('bsc'), // unlisted but live (no markets yet)
  '196': doloUrl('x-layer'),
  '1101': doloUrl('polygon-zkevm'),
  '3637': doloUrl('botanix'), // unlisted but live
  '5000': doloUrl('mantle'),
  '8453': doloUrl('base'),
  '42161': doloUrl('arbitrum'),
  '80094': doloUrl('berachain-mainnet'),
}

export const dolomiteSubgraphUrl = (chainId: string): string | undefined =>
  DOLOMITE_SUBGRAPH_URLS[chainId]

export const hasDolomiteSubgraph = (chainId: string): boolean =>
  chainId in DOLOMITE_SUBGRAPH_URLS
